/* Aria Robotics — Startseite. Ported aus page-home.jsx. */
import { Container, Section, SectionHead, Eyebrow, Btn, Panel, IconTile, ImageFrame, go } from '@/ui';
import { ScrollHero } from '@/components/ScrollHero';
import { AriaData as D } from '@/data';

interface Step { n: string; icon: string; h: string; p: string; }
const STEPS: Step[] = [
  { n: '01', icon: 'calendar-check', h: 'Vorbestellen', p: 'Sie sichern sich einen Platz in der ersten Auslieferungswelle — unverbindlich und ohne Vorkasse.' },
  { n: '02', icon: 'package-open', h: 'Einrichten lassen', p: 'Ein Aria-Techniker bringt Nestor zu Ihnen und richtet alles gemeinsam mit Ihnen ein.' },
  { n: '03', icon: 'heart-handshake', h: 'Zeit gewinnen', p: 'Nestor lernt Ihren Alltag kennen und übernimmt Schritt für Schritt mehr — in Ihrem Tempo.' },
];

export function Home() {
  return (
    <div>
      <ScrollHero />

      {/* Werte */}
      <Section tone="page">
        <Container>
          <SectionHead eyebrow="Wofür wir stehen" title="Fürsorge mit Substanz" lead="Vier Grundsätze bestimmen, wie Nestor sich in Ihrem Zuhause verhält — und wie wir dieses Unternehmen führen." />
          <div className="ar-grid-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 20, marginTop: 44 }}>
            {D.values.map((v) => (
              <Panel key={v.h} hover>
                <IconTile name={v.icon} />
                <h3 style={{ fontSize: 19, color: 'var(--text-100)', margin: '16px 0 8px', letterSpacing: '-0.01em' }}>{v.h}</h3>
                <p style={{ fontSize: 14.5, color: 'var(--text-200)', lineHeight: 1.6, margin: 0 }}>{v.p}</p>
              </Panel>
            ))}
          </div>
        </Container>
      </Section>

      {/* Produkt-Teaser */}
      <Section tone="sunken">
        <Container>
          <div className="ar-split" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 56, alignItems: 'center' }}>
            <ImageFrame id="home-product" ratio="4/3" src="assets/nestor/lego.webp" placeholder="Nestor 01 in Aktion" />
            <div>
              <SectionHead eyebrow="Nestor 01" title="Der Erste, der wirklich hilft" lead="Kein Gadget, kein Gimmick. Nestor übernimmt echte Aufgaben im Haushalt — und sagt ehrlich, wenn etwas noch nicht geht." />
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginTop: 28 }}>
                {D.capabilities.map((c) => (
                  <div key={c.h} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                    <IconTile name={c.icon} size={40} />
                    <div>
                      <div style={{ fontSize: 15.5, fontWeight: 600, color: 'var(--text-100)' }}>{c.h}</div>
                      <div style={{ fontSize: 13.5, color: 'var(--text-200)', lineHeight: 1.5, marginTop: 2 }}>{c.p}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ marginTop: 32 }}>
                <Btn variant="primary" size="md" iconRight="arrow-right" onClick={() => go('/nestor-01')}>Alle Fähigkeiten & Specs</Btn>
              </div>
            </div>
          </div>
        </Container>
      </Section>

      {/* So funktioniert's */}
      <Section tone="page">
        <Container>
          <SectionHead align="center" eyebrow="So einfach beginnt es" title="In drei Schritten zuhause angekommen" style={{ marginBottom: 44 }} />
          <div className="ar-grid-3" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20 }}>
            {STEPS.map((s) => (
              <Panel key={s.n} variant="flat" style={{ position: 'relative' }}>
                <span style={{ fontFamily: 'var(--font-mono)', fontSize: 13, color: 'var(--primary-200)', letterSpacing: '0.1em' }}>{s.n}</span>
                <div style={{ marginTop: 14 }}><IconTile name={s.icon} /></div>
                <h3 style={{ fontSize: 19, color: 'var(--text-100)', margin: '14px 0 8px' }}>{s.h}</h3>
                <p style={{ fontSize: 14.5, color: 'var(--text-200)', lineHeight: 1.6, margin: 0 }}>{s.p}</p>
              </Panel>
            ))}
          </div>
        </Container>
      </Section>

      {/* CTA */}
      <Section tone="ink" style={{ padding: '80px 0' }}>
        <Container>
          <div style={{ textAlign: 'center', maxWidth: 640, margin: '0 auto' }}>
            <Eyebrow tone="inverse">More time for what matters</Eyebrow>
            <h2 style={{ fontSize: 'clamp(30px, 4.5vw, 46px)', fontWeight: 800, letterSpacing: '-0.02em', color: '#fff', margin: '14px 0 0', lineHeight: 1.08 }}>Sichern Sie sich einen der ersten Nestor.</h2>
            <p style={{ fontSize: 18, color: 'rgba(255,255,255,0.78)', marginTop: 16 }}>Wir liefern bewusst langsam und begleiten jede Einrichtung persönlich. Die erste Welle ist begrenzt.</p>
            <div style={{ marginTop: 30, display: 'flex', justifyContent: 'center', gap: 12, flexWrap: 'wrap' }}>
              <Btn variant="cta" size="lg" iconRight="arrow-right" onClick={() => go('/kontakt')}>Jetzt vorbestellen</Btn>
              <Btn variant="ghostInverse" size="lg" onClick={() => go('/service')}>Service & Support</Btn>
            </div>
          </div>
        </Container>
      </Section>
    </div>
  );
}
